module.exports = __webpack_public_path__ + "static/media/Apple-Packer-Robotics-Plus.a6cbc3cf.jpg";